import styles from './email-templates.module.scss';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import PageTitle from '../../page-title/page-title';
import EvaluationEmail from './evaluation-email/evaluation-email';
import ExternalCourses from './external-courses/external-courses';
import ConfirmationCourseRegistration from './confirmation-course-registration/confirmation-course-registration';
import MovingCourses from './moving-courses/moving-courses';
import CourseCancellation from './course-cancellation/course-cancellation';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailTemplatesProps { }

export function EmailTemplates(props: EmailTemplatesProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);
  const navigateToTabThree = () => setSelectedTab(2);
  const navigateToTabFour = () => setSelectedTab(3);
  const navigateToTabFive = () => setSelectedTab(4);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t('emailTemplates.emailTemplates')} subtitle={`(${t("standard.admin")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t('emailTemplates.evaluationEmail')} onClick={navigateToTabOne} />
                <Tab label={t('emailTemplates.externalCourses')} onClick={navigateToTabTwo} />
                <Tab label={t('emailTemplates.confirmationOfCourseRegistration')} onClick={navigateToTabThree} />
                <Tab label={t('emailTemplates.movingCourses')} onClick={navigateToTabFour} />
                <Tab label={t('emailTemplates.cancelingCourse')} onClick={navigateToTabFive} />
              </Tabs>
            </Box>
            <div>
              {selectedTab === 0 && <EvaluationEmail />}
              {selectedTab === 1 && <ExternalCourses />}
              {selectedTab === 2 && <ConfirmationCourseRegistration />}
              {selectedTab === 3 && <MovingCourses />}
              {selectedTab === 4 && <CourseCancellation />}
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default EmailTemplates;
